import { usePut } from '../../HttpClient';
import { CreateRateRequest, RateModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateBankOfEnglandBaseRate() {
  const put = usePut(true, "tms");
  const updateBankOfEnglandBaseRate = (rateId: string, request: CreateRateRequest): Promise<RateModel> =>
    put(`${referenceDataBaseUrl}/rate-types/BOE/rates/${rateId}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ rateId, request }: { rateId: string; request: CreateRateRequest }) =>
      await updateBankOfEnglandBaseRate(rateId, request),
  });
}
